export enum InputType {
    DROPDOWN = "Dropdown",
    SEARCHBAR = "Searchbar",
    DATESEARCH = "Searchdate",
    BLANK = "Blank",
    STATUS = "Status",
}